export var IntegrationsSubject;
(function (IntegrationsSubject) {
    IntegrationsSubject["Page"] = "integrations-hub-page";
    IntegrationsSubject["IntegrationCard"] = "integration-card";
    IntegrationsSubject["IntegrationCollapse"] = "integration-collapse";
    IntegrationsSubject["IntegrationCardLink"] = "integration-card";
    IntegrationsSubject["AgentWizardLink"] = "agent-wizard-link";
    IntegrationsSubject["HubEmptyState"] = "hub-empty-state";
    IntegrationsSubject["IntegrationPage"] = "integration-page";
    IntegrationsSubject["CustomIntegrationPage"] = "custom-integration-page";
    IntegrationsSubject["InfoCardLogsToken"] = "info-card-logs-token";
    IntegrationsSubject["InfoCardMetricsToken"] = "info-card-metrics-token";
    IntegrationsSubject["InfoCardTracingToken"] = "info-card-tracing-token";
    IntegrationsSubject["MarkdownRender"] = "markdown-render";
    IntegrationsSubject["SearchInput"] = "search-input";
    IntegrationsSubject["IntegrationDescription"] = "integration-description";
    IntegrationsSubject["GiveFeedback"] = "integration-give-feedback";
    IntegrationsSubject["ThanksForFeedback"] = "integration-thanks-for-feedback";
    IntegrationsSubject["Tabs"] = "integrations-tabs";
    IntegrationsSubject["SelectTagButton"] = "select-tag-button";
})(IntegrationsSubject || (IntegrationsSubject = {}));
export var ISidebarTagsSubject;
(function (ISidebarTagsSubject) {
    ISidebarTagsSubject["Checkbox"] = "sidebar-tag-checkbox";
})(ISidebarTagsSubject || (ISidebarTagsSubject = {}));
export var BundleTypes;
(function (BundleTypes) {
    BundleTypes["OsdDashboards"] = "OSD_DASHBOARD";
    BundleTypes["OsdAlerts"] = "LOG_ALERT";
    BundleTypes["MetricsDashboards"] = "GRAFANA_DASHBOARD";
    BundleTypes["MetricsAlerts"] = "GRAFANA_ALERT";
})(BundleTypes || (BundleTypes = {}));
export var IntegrationType;
(function (IntegrationType) {
    IntegrationType["COLLECTOR"] = "COLLECTOR";
    IntegrationType["AGENT"] = "AGENT";
})(IntegrationType || (IntegrationType = {}));
export var IntegrationsIQ;
(function (IntegrationsIQ) {
    IntegrationsIQ["UserPromptTooLong"] = "user-prompt-too-long";
})(IntegrationsIQ || (IntegrationsIQ = {}));
export var CustomIntegrationPages;
(function (CustomIntegrationPages) {
    CustomIntegrationPages["Curl"] = "cURL-data";
    CustomIntegrationPages["Kubernetes"] = "Kubernetes";
    CustomIntegrationPages["NodeJs"] = "Node-js";
    CustomIntegrationPages["Java"] = "Java";
    CustomIntegrationPages["HTTP"] = "HTTP";
    CustomIntegrationPages["Python"] = "Python";
    CustomIntegrationPages["dotnet"] = "dotnet";
    CustomIntegrationPages["AwsS3Bucket"] = "AWS-S3-Bucket";
    CustomIntegrationPages["Filebeat"] = "Filebeat-data";
    CustomIntegrationPages["Rsyslog"] = "Rsyslog-data";
})(CustomIntegrationPages || (CustomIntegrationPages = {}));
export var CustomIntegrationPagesProducts;
(function (CustomIntegrationPagesProducts) {
    CustomIntegrationPagesProducts["Logs"] = "logs";
    CustomIntegrationPagesProducts["Metrics"] = "metrics";
    CustomIntegrationPagesProducts["Traces"] = "traces";
    CustomIntegrationPagesProducts["Content"] = "content";
})(CustomIntegrationPagesProducts || (CustomIntegrationPagesProducts = {}));
//# sourceMappingURL=integrations.enum.js.map